var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      !_vm.isEdit
        ? _c(
            "b-card-actions",
            {
              attrs: {
                "show-loading": _vm.uploading || _vm.fetching,
                "action-collapse": "",
                title: _vm.$t("Importar arquivo de conciliação"),
              },
            },
            [
              _c(
                "FormulateForm",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.uploading,
                      expression: "!uploading",
                    },
                  ],
                  ref: "form",
                },
                [
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { attrs: { md: "12" } },
                        [
                          _c("FormulateInput", {
                            ref: "conciliationFile",
                            staticClass: "required",
                            attrs: {
                              id: "reconciliation-file",
                              type: "uploader",
                              "max-files": "1",
                              theme: "list",
                              deletable: !_vm.isEdit,
                              meta: true,
                              accept: ".txt",
                              label: _vm.$t("Arquivo Pix"),
                              validation: "required",
                              "help-text": _vm.$t(
                                "Arraste o arquivo de conciliação Pix aqui (ou clique para selecionar o arquivo)"
                              ),
                            },
                            on: {
                              input: _vm.uploadFile,
                              delete: _vm.removeFiles,
                            },
                            model: {
                              value: _vm.localConciliationFile,
                              callback: function ($$v) {
                                _vm.localConciliationFile = $$v
                              },
                              expression: "localConciliationFile",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _c(
            "transition",
            { attrs: { name: "fade" } },
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { md: "12" } },
                    [
                      _c(
                        "b-card-actions",
                        {
                          staticClass: "h-345",
                          attrs: {
                            "show-loading": _vm.saving,
                            "action-collapse": "",
                            title:
                              _vm.$t("Dados da Conciliação") +
                              " #" +
                              _vm.conciliation.id,
                          },
                        },
                        [
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                { attrs: { md: "3" } },
                                [
                                  _c("FormulateInput", {
                                    attrs: {
                                      id: "conciliation-store",
                                      value: _vm.conciliation.store,
                                      type: "label",
                                      filter: "storeName",
                                      label: _vm.$t("Loja"),
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "b-col",
                                { attrs: { md: "3" } },
                                [
                                  _c("FormulateInput", {
                                    attrs: {
                                      id: "conciliation-checking-account",
                                      value:
                                        _vm.conciliation.checkingAccount.name,
                                      type: "label",
                                      label: _vm.$t("Conta Corrente"),
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "b-col",
                                { attrs: { md: "2" } },
                                [
                                  _c("FormulateInput", {
                                    attrs: {
                                      id: "conciliation-movement-date",
                                      value: _vm.conciliation.receivedDate,
                                      type: "label",
                                      filter: "date",
                                      label: _vm.$t("Data do Movimento"),
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "b-col",
                                { attrs: { md: "2" } },
                                [
                                  _c("FormulateInput", {
                                    attrs: {
                                      id: "invoice-status",
                                      value: _vm.$t(
                                        "Reconciliation_" +
                                          _vm.conciliation.status
                                      ),
                                      type: "label",
                                      label: _vm.$t("Status"),
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "b-col",
                                { attrs: { md: "2" } },
                                [
                                  _c("FormulateInput", {
                                    attrs: {
                                      id: "invoice-percent-completed",
                                      value:
                                        _vm.conciliation.percentCompleted / 100,
                                      type: "label",
                                      filter: "percentage",
                                      label: _vm.$t("% Concluído"),
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { md: "12" } },
                    [
                      _c(
                        "b-tabs",
                        { attrs: { fill: "" } },
                        [
                          _c(
                            "b-tab",
                            { attrs: { title: _vm.$t("Transações") } },
                            [
                              _c("conciliation-item-table", {
                                attrs: {
                                  saving: _vm.saving,
                                  fetching: _vm.fetching,
                                },
                                on: {
                                  "get-data": _vm.getData,
                                  "item-skip": _vm.onSkip,
                                  "item-match": _vm.onMatch,
                                  "item-unmatch": _vm.onUnmatch,
                                  "item-reset": _vm.onReset,
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
      _c("skip-item", {
        ref: "skipModal",
        attrs: { "conciliation-id": _vm.conciliation.id },
      }),
      _c("match-item", {
        ref: "matchModal",
        attrs: { conciliation: _vm.conciliation },
      }),
      _c("unmatch-item", {
        ref: "unmatchModal",
        attrs: { conciliation: _vm.conciliation },
      }),
      _vm.$can("Update", "SantanderPixConciliation") && !_vm.isFinished
        ? _c("fab", {
            attrs: {
              "main-tooltip": _vm.$t("Finalizar Conciliação"),
              "main-icon": "check",
              busy: _vm.saving,
            },
            on: { click: _vm.onFinishConciliation },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }